import { AuditAPI } from './auditApi';
import { CollectionsApi, collectionsAPI } from './collectionApi';
import { CasesApi, CasesAPI } from './casesApi';
import { WorkspacesApi, WorkspacesAPI } from './workspacesApi';
import { AuthenticationAPI, AuthenticationApi } from './authenticationApi';
import { ReportApi, ReportAPI } from './reportApi';
import { QuotaAPI } from './quotaApi';
import { NotificationsAPI } from './notificationsApi';
import { TagsAPI } from './tagsApi';

export interface ApiService {
    workspaces: WorkspacesApi;
    cases: CasesApi;
    collections: CollectionsApi;
    authentication: AuthenticationApi;
    report: ReportApi;
}

class Api implements ApiService {
    workspaces = new WorkspacesAPI();
    cases = new CasesAPI();
    collections = new collectionsAPI();
    authentication = new AuthenticationAPI();
    report = new ReportAPI();
    audit = new AuditAPI();
    quota = new QuotaAPI();
    tags = new TagsAPI();
    notifications = new NotificationsAPI();
}

const api = new Api();
export default api;
